import { useContext, useEffect, useState } from 'react';
import { StateContext, DispatchContext } from '../../../App';
import { FormattedMessage } from 'react-intl';

import { dispatchCompositionArticles, dispatchUserSelections, dispatchSubheaderTextUpdate } from '../../../functions/functions';
import SmallCard from '../../SmallCard/SmallCard';
import Navbar from './Navbar';

import './SideMenu.css';

const TABS = [
    {
        id: "modify",
        note: "modify_note"
    },
    {
        id: "finishes",
        note: "finishes_note"
    },
    // {
    //     id: "add",
    //     note: "add_note"
    // }
];

const SUMMARY_BUTTONS = [
    {
        id: "pdf",
        note: ""
    },
    {
        id: "img",
        note: ""
    },
    {
        id: "link",
        note: ""
    }
];

const Section = ({ tab, itemID, name, data, userSelections, updateComposition }) => {
    //selections contains array of selected options ids
    const appState = useContext(StateContext);

    const [ activeCards, setActiveCards ] = useState([]);
    const [ activeSubsection, setActiveSubsection ] = useState('section0');
    const [ isFinishSectionOpen, setIsFinishSectionOpen ] = useState(false);
     
    useEffect(() => {
        if (userSelections) {
            if (tab === 'modify') {
                userSelections.length > 0 ? setActiveCards(userSelections[0].articles) : setActiveCards([]);
            } else {
                userSelections.length > 0 ? setActiveCards(userSelections[0].colors) : setActiveCards([]);
            }
        }
    }, [userSelections]);

    
    const selectCards = (cardID, subsection) => {
        //typeof CradID: number
        setActiveSubsection(subsection);
        let selections = activeCards.slice();
        if (subsection === activeSubsection) {
            if (selections.includes(cardID)) {
                
                selections.splice(selections.indexOf(cardID), 1);
            } else {
                selections[0] = cardID;
            };
            setActiveCards(selections);
        } else {
            if (selections.includes(cardID)) {
                selections.splice(selections.indexOf(cardID), 1)
            } else {
                selections.push(cardID);
            };
            setActiveCards(selections);
        };
        let optionArticle;
        let optionMaterials = [];
        // console.log('SELECTIONS', selections)
        data.forEach(datum => {
            if (selections.length > 0) {
                selections.forEach(id => {
                    let hasRequiredArt = tab === 'modify' ?
                    (datum.articles.filter(art => art.id === id).length > 0 ? true : false) :
                    (datum.colors.filter(art => art.id === id).length > 0 ? true : false) ;
                    if (hasRequiredArt) {
                        
                        optionArticle = tab === 'modify' ? datum.articles.filter(art => art.id === id)[0] : datum.colors.filter(art => art.id === id)[0];
                        let optionArtMaterials = optionArticle.materials;
                        optionMaterials.push({
                            id,
                            materials: optionArtMaterials
                        });
                    };
                });
            };
            
        })
        // console.log('element', optionArticle);
        // console.log('user selections', selections)
        // updateSpecs(cardID);
        updateComposition(tab, name, itemID, selections);
    };

    const toggleFinishSection = () => {
        setIsFinishSectionOpen(!isFinishSectionOpen);
    };

    const Subsection = ({id, data}) => {
        
        return (
            <>
                {
                    data.map(art => {
                        {/* console.log('art',tab, art) */}
                        return (
                            <SmallCard 
                                key={art.id}
                                subsection={id}
                                cardSize={tab === 'modify' ? '' : 'xxs' }
                                cardID={art.id}
                                nameID={itemID === 'fabrics' ? art.name : art.full_name}
                                imgUrl={art.image}
                                activeCards={activeCards}
                                selectCards={selectCards}
                            /> 
                        )
                    })
                }
            </>
        )
    };

    const ModifySection = () => {
        return (
            <>
                <span className='section-title'>
                    <FormattedMessage 
                        id={name}
                        defaultMessage={name}
                    />
                </span>
                <div className='section-gallery'>
                    {
                        data.map((item, _i) => {
                            return (
                                <Subsection 
                                    key={_i}
                                    id={`section${_i}`}
                                    data={item.articles}
                                />
                            )
                        })
                    }
                </div>
            </>
        )
    };

    const FinishesSection = () => {
        // console.log('finish data', data)
        const [ finishesData, setFinishesData ] = useState();
        useEffect(() => {
            setFinishesData(data);
            // if (itemID === 'materials') {
            //     setFinishesData(appState.data.compositionMaterials)
            // }
        }, [appState.data.compositionMaterials])
        return (
            <>
                <span 
                    className={isFinishSectionOpen ? 'section-title title-xs title-bg pointer ' : 'section-title title-xs pointer'} 
                    onClick={() => toggleFinishSection()}
                >
                    <FormattedMessage 
                        id={name}
                        defaultMessage={name}
                    />
                </span>
                <div className='section-gallery' >
                    {
                        isFinishSectionOpen && finishesData !== undefined ? finishesData.map((item, _i) => {
                            {/* console.log('data item', item) */}
                            return (
                                
                                <Subsection 
                                    key={`section${_i}`}
                                    id={`section${_i}`}
                                    data={item.colors}
                                />
                                
                            )
                        }) : null
                    }
                </div>
            </>
        )
    }; 

    return (
        <div className='li-body-section'>
            {
                tab === 'modify' && <ModifySection />
            }
            {
                tab === 'finishes' && <FinishesSection />
            }
        </div>
    )
};

const Summary = () => {
    const appState = useContext(StateContext);

    const [specs, setSpecs] = useState();

    useEffect(() => {
        setSpecs(appState.specs);
    }, [appState.specs])
    
    const SummaryItem = ({nameID, imgUrl, measurements}) => {
        return (
            <div className='list-item'>
            <div className='summary-wrap'>
            <span className='summary-li-title'>{nameID}</span>
            {
                imgUrl && measurements && <div className='summary-li-body'>
                <div className='summary-li-body-column'>
                    <img className='summary-img' src={imgUrl} alt={nameID}  />
                </div>
                
                <table cellSpacing={0} className='summary-li-body-column'>
                    <thead>
                        <tr>
                            <th>
                            <FormattedMessage 
                                id='measurements'
                                defaultMessage='Measurements'
                            />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr >
                            <td>
                                <FormattedMessage 
                                    id='length'
                                    defaultMessage='Length'
                                />
                            </td>
                            <td>{measurements.length}</td>
                        </tr>
                        <tr>
                            <td>
                                <FormattedMessage 
                                    id='depth'
                                    defaultMessage='Depth'
                                />
                            </td>
                            <td>{measurements.depth}</td>
                        </tr>
                        <tr>
                            <td>
                                <FormattedMessage 
                                    id='height'
                                    defaultMessage='Height'
                                />
                            </td>
                            <td>{measurements.height}</td>
                        </tr>
                        {
                            measurements.seat_height && <tr>
                            <td>
                                <FormattedMessage 
                                    id='seat_height'
                                    defaultMessage='Seat height with cushion'
                                />
                            </td>
                            <td>{measurements.seat_height}</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
            }
            
            </div>
            
            
            {/* <figure className='portrait'>
                
                <figcaption className='fig-caption'>
                   {nameID}
                </figcaption>
            </figure> */}
        </div>
        )
    };

    return (
        <>
            {
                specs !== undefined ?  specs.map(item => {
                    
                    return (
                        <SummaryItem
                            key={item.id}
                            nameID={item.full_name}
                            imgUrl={item.image}
                            measurements={item.measurements}
                        /> 
                    )
                }) : null
            }
        </>  
    )
}


const ListItem = ({ tab, itemID, name, activeItems, updateActiveItems, itemOptions, userSelections, updateComposition, deleteItem }) => {
    //itemOptions - all "product" options data for EDEN002 module (backrests, armrests and loro cuscini);
    //userSelections - options selected for all items (when trying to provide filtered data it couldnt update)
    const appState = useContext(StateContext);

    const [ isActive, setIsActive ] = useState(false);
    const [ sections, setSections ] = useState([]);
    const [ data, setData ] = useState({});

    const [ hasSelections, setHasSelections ] = useState(false);
    const [ itemSelections, setItemSelections ] = useState([]);
    const [ hasOptions, setHasOptions ] = useState();
    const [ optionData, setOptionData ] = useState();

    const toggleListItem = (id) => {
        updateActiveItems(id)
    };

    // useEffect(() => {
    //     if (itemID === 'materials') {
    //         setData
    //     }
    // }, [appState.data.compositionMaterials])

    useEffect(() => {
        
        if (activeItems.includes(itemID)) {
            setIsActive(true)
        } else {
            setIsActive(false)
        }
    }, [activeItems, itemID]);    

    useEffect(() => {
        if (itemOptions !== "undefined" || undefined) {
            let sections = []; //to know how many sections to render (backrest, armrest etc)
            itemOptions.forEach(option => {
                return sections.includes(option.kind) ? null : sections.push(option.kind)
            });
            setSections(sections);

            let data = {};
            sections.forEach(section => {
                data[section] = itemOptions.filter(option => option.kind ===  section);
            });
            setData(data);
        }
        
    }, [itemOptions, appState.data.compositionMaterials]);

    useEffect(() => {
        //SETTING UP USER SELECTIONS
        if (tab === 'modify') {
            if (userSelections !== undefined) {
                // console.log('userSelections',userSelections)
                //==========================================================================================
                //1. When userSelections is updated we have to filter it by itemID and check if it has 
                //   selections for backrest, armrest etc
                //==========================================================================================
                let itemSelections = userSelections.filter(os => os.item_id === itemID)[0].options; //item selections for this itemID (any selection)
                //==========================================================================================
                //2. If there are some selections set hasSelections to true and set itemSelections 
                //==========================================================================================
                if (itemSelections !== undefined) {
                    //There are SOME SELECTIONS
                    setHasSelections(true);
                    setItemSelections(itemSelections);
                    //======================================================================================
                    //3. We have to collect all options available for user selections if there are any
                    //======================================================================================
                    let optionsarray = []; //array where options available for user selections will be accumulated
                    //for each section (or kind) we have to find its selections and relative options and push them to the options array
                    let hasOptions = false;
                    itemSelections.forEach(selectionByKind => {
                        if (selectionByKind.kind.toLowerCase() !== 'cushions') {
                            let optionDataFilteredByKind = itemOptions.filter(option => option.kind === selectionByKind.kind)[0].articles; //option data for kind e.g. armrest/backrest etc
                            // console.log('GOD optionDataFilteredByKind', optionDataFilteredByKind)
                            if (optionDataFilteredByKind.some(option => option.options !== "undefined")) {
                                hasOptions = true;
                            };
                            selectionByKind.articles.forEach(id => {
                                let datafound = optionDataFilteredByKind.filter(dataArt => dataArt.id === id);
                                if (datafound.length > 0 && datafound[0].options !== "undefined") {
                                    let optiondata = datafound[0].options
                                    optionsarray.push(optiondata)
                                    setOptionData(optionsarray)
                                }
                            })
                        }
                        
                    });
                    setHasOptions(hasOptions);
                } else {
                    setHasSelections(false);
                    setHasOptions(false);
                    setOptionData([]);
                }
            }
        } else if (tab === 'finishes') {
            console.log('USER MATERIALS', userSelections)
            if (userSelections !== undefined) {
                // console.log('USER MATERIALS', userSelections)
                setHasSelections(true);
                setItemSelections(userSelections);

               
            } else {
                setHasSelections(false);
            }
        }
        
        
    }, [userSelections, itemOptions, itemID, tab]);
    
    return (
        <div className='list-item' id={itemID}>
            <div className='li-header' onClick={() => toggleListItem(itemID)}>
                <FormattedMessage 
                    id={name}
                    defaultMessage={name}
                />
            </div>
            {
                isActive && <div className='li-body'>
                    {
                        sections.length > 0 ? sections.map(section => {
                            return (
                                <Section 
                                    key={section}
                                    tab={tab}
                                    itemID={itemID}
                                    name={section}
                                    data={data[section]}
                                    userSelections={hasSelections ? itemSelections.filter(opt => opt.kind === section) : []}
                                    updateComposition={updateComposition}
                                />
                            )
                        }) : null
                    }
                    {
                        hasOptions && optionData.map(option => {
                            {/* console.log('cushion sel', option) */}
                            return (
                                <Section 
                                    key={option[0].kind}
                                    tab={tab}
                                    itemID={itemID}
                                    name={option[0].kind}
                                    data={option}
                                    userSelections={hasSelections ? itemSelections.filter(opt => opt.kind === option[0].kind) : []}
                                    updateComposition={updateComposition}
                                />
                            )
                        })
                        
                    }
                    {/* DELETE BUTTON TEMPORARILY DISABLED: NOT REQUIRED X JUòY RELEASE */}
                    {/* <button className='navbar-btn li-delete' onClick={() => deleteItem(id)}>
                        Elimina
                    </button> */}
                </div>
            }
        </div>
    )
};


const SideMenu = () => {
    const dispatch = useContext(DispatchContext);
    const appState = useContext(StateContext);

    const { isSideMenuOpen, production, tab, isSummaryOpen, subheaderText, isShared } = appState.appSettings;
    const { articles } = appState.data;
    const articlesSelections = appState.selections.articles; 
    const materialSelections = appState.selections.materials;
    const fabricSelections = appState.selections.fabrics;
    
    const [ firstLoad, setFirstLoad ]               = useState(true);
    const [ activeTab, setActiveTab ]               = useState(tab);
    const [ userArticles, setUserArticles ]         = useState(articlesSelections); //composition articles selected options 
    const [ userMaterials, setUserMaterials ]       = useState(materialSelections);
    const [ userFabrics, setUserFabrics ]           = useState(fabricSelections);
    const [ itemsList, setItemsList ]               = useState(articles);
    const [ activeItems, setActiveItems ]           = useState([]);
    // const [ itemsIdAndMaterials, setItemsIdAndMaterials ]     = useState([]);

    const [ rodaMaterials, setRodaMaterials ]       = useState(appState.data.rodaMaterials); //array of all RODA material available
    const [ hasMaterials, setHasMaterials ]         = useState();
    const [ hasFabrics, setHasFabrics ]             = useState();
    const [ defaultMaterials, setDefaultMaterials ] = useState([]); 
    const [ materials, setMaterials ]               = useState([]);
    const [ fabrics, setFabrics ]                   = useState();
    const [ specs, setSpecs ]                       = useState();


    let proxy = production ? '' : 'https://serene-springs-29711.herokuapp.com/';

    const updateActiveItems = (id) => {
        let hasItem = itemsList.filter(i => i.item_id === id);
        let itemName, subheaderTextUpd;

        let ids = activeItems.slice();
        if (ids.includes(id)) {
            ids.splice(ids.indexOf(id), 1);
            if (hasItem.length > 0) {
                itemName = hasItem[0].full_name;
                subheaderTextUpd = {...subheaderText, info: null, note: ''};
                dispatchSubheaderTextUpdate(dispatch, subheaderTextUpd)
            };
        } else {
            ids.push(id);
            if (hasItem.length > 0) {
                itemName = hasItem[0].full_name;
                subheaderTextUpd = {...subheaderText, info: null, note: itemName};
                dispatchSubheaderTextUpdate(dispatch, subheaderTextUpd)
            };
        };
        setActiveItems(ids);
    };

    useEffect(() => {
        // console.log('roda mat', appState.data.rodaMaterials)
        setRodaMaterials(appState.data.rodaMaterials)
    }, [appState.data.rodaMaterials])

    const getUserArticlesData = (newUserArticles) => {
        // console.log('NEW USER ARTS', newUserArticles)
        let updatedSpecs = [];
        let updatedMaterials = [];
        defaultMaterials.forEach(dmat => updatedMaterials.push(dmat));
        let compositionMaterials = [];

        const getNewMaterials = (inputMaterials) => {
            // console.log('input materials',inputMaterials)
            let inputMaterialsSlice = JSON.parse(JSON.stringify(inputMaterials));
            inputMaterialsSlice.forEach(inputMaterial => {
                //REPLACE COLOR CODES BY FULL DATA WITH IMAGE URL, NAME
                let colors = inputMaterial.colors.slice();
                colors.forEach(color => {
                    let newData = rodaMaterials.filter(i => i.id === color)[0];
                    colors.splice(colors.indexOf(color), 1, newData)
                });
                // console.log('new colors', colors);
                inputMaterial.colors = colors;
            });
            return inputMaterialsSlice;
        };
        
        newUserArticles.forEach(item => {
            let itemData = articles.filter(art => art.item_id === item.item_id)[0];
            
            if (itemData) {
                let dataObj = {
                    id: itemData.id, 
                    full_name: itemData.full_name, 
                    image: itemData.image, 
                    measurements: itemData.measurements
                };
                updatedSpecs.push(dataObj);

                let materialObj = {
                    id: item.id,
                    materials: getNewMaterials(itemData.materials)
                };
                compositionMaterials.push(materialObj);

                if (item.options !== undefined) {
                    // console.log('I have options');
                    item.options.forEach(optKind => {
                        let optionKindData = itemData.options.filter(opt => opt.kind === optKind.kind);
                        optKind.articles.forEach(optArt => {
                            let artData; 
                            optionKindData.forEach(kind => {
                                if (kind.articles.filter(art => art.id === optArt)[0]) {
                                    artData = kind.articles.filter(art => art.id === optArt)[0]
                                };
                            });
                            
                            if (artData) {
                                let dataObj = {
                                    id: artData.id, 
                                    full_name: artData.full_name, 
                                    image: artData.image, 
                                    measurements: artData.measurements
                                };
                                updatedSpecs.push(dataObj);

                                let materialObj = {
                                    id: artData.id,
                                    materials: getNewMaterials(artData.materials)
                                };
                                compositionMaterials.push(materialObj);
                            } else {
                                // console.error('no option data found');
                                if (optKind.kind.toLowerCase() === 'cushions') {
                                    updatedSpecs.push({
                                        id: 999,
                                        full_name: `Cushion x ${optArt}`
                                    })
                                }
                                
                            };
                        });
                    })
                };
                // console.log('updated specs', updatedSpecs);
                let index = updatedSpecs.indexOf(updatedSpecs.filter(i => i.id === 999)[0]);
                updatedSpecs.push(updatedSpecs.splice(index, 1)[0]);

                setSpecs(updatedSpecs);
                dispatch({
                    type: 'SET_SPECS',
                    payload: updatedSpecs
                });

                if (compositionMaterials.length > 0) {
                    compositionMaterials.forEach(idm => {
                        idm.materials.forEach(material => {
                            let hasMaterial = updatedMaterials.filter(updMaterial => updMaterial.kind === material.kind).length > 0 ? true : false;
                            if (!hasMaterial) {
                                updatedMaterials.push(material)
                            } 
                        })
                    });
                };
                
                // console.log('updated materials', updatedMaterials)
                setMaterials(updatedMaterials);
                dispatch({
                    type: 'SET_COMPOSITION_MATERIALS',
                    payload: updatedMaterials
                })

            } else {
                console.error('no element found')
            }
        })
    };

    const updateOptions = (kind, itemID, selections) => {
        // console.log('1. UPDATING OPTIONS:', kind, itemID, selections)
        const template = {
            item_id: undefined,
            id: undefined,
            collection: undefined
        };

        let newUserArticles; //array of composition articles with their options selected. Gets values from userArticles = appState.selections.articles
        if (userArticles ===  undefined) {
            newUserArticles = [];
        }  else {
            newUserArticles = userArticles.slice(); 
        };

        let ids = []; //array that will contain items ids
        if (newUserArticles.length > 0) {
            newUserArticles.forEach(i => ids.push(i.item_id)); //e.g. [41] NB! item_id != id: item_id is assigned to an article when it's been added to the composition and is generated using article id + its array index
        };

        if (itemID|kind|selections !== undefined) {
            // ===============================================================
            // itemSelections is an array that contains options selected by user.
            // Options are grouped by their kind:
            // { kind: backrest, articles: [42] }
            // ===============================================================
            let index = ids.indexOf(itemID);
            let itemSelections; // options selected for the item found by itemID
            if (newUserArticles.length > 0) {
                itemSelections = newUserArticles[index].options;
            } else {
                itemSelections = undefined;
            };
            
            if (itemSelections === undefined) {
                //NO PRIOR SELECTED OPTIONS at all: {...selections: articles: [{item_id:##, ...options: undefined}, {...}]}
                console.log('2. I HAVE NO PRIOR SELECTIONS')
                // articles.forEach(article => {
                //     if (!ids.includes(article.id)) {
                //         let newItem = {...template};
                //         Object.keys(newItem).forEach(key => {
                //             newItem[key] = article[key];
                //         });
                //         newItem.options = undefined;
                //         newItem.fabrics = undefined;
                //         newItem.materials = undefined;
                //         newUserArticles.push(newItem); 
                //     } 
                // });

                newUserArticles[0].options = [];
                let obj = {
                    kind: kind,
                    articles: selections
                };
                newUserArticles[0].options.push(obj);
                dispatch({
                    type:  'SET_ARTICLES',
                    payload: newUserArticles
                });
                //SETTING DEFAULT MATERIAL FOR OPTIONS
                let otherMaterials = userMaterials.filter(userMaterial => userMaterial.kind !== 'structure')
                // console.log('OTEHR MAT', otherMaterials)
                if (otherMaterials.length === 0) {
                    let newUserMaterials = userMaterials.slice();
                    let optionMaterials = articles.filter(art => art.item_id === itemID)[0].options
                    .filter(opt => opt.kind  === kind)[0].articles
                    .filter(art => art.id === selections[0])[0].materials;
                    optionMaterials.forEach(optMat => {
                        let kind = optMat.kind;
                        let colors = [];
                        colors.push(optMat.colors[0]);
                        newUserMaterials.push({kind, colors});
                        setUserMaterials(newUserMaterials);
                    });
                    dispatch({
                        type: 'SET_MATERIALS',
                        payload: newUserMaterials
                    });
                    // dispatch({
                    //     type:  'SET_USER_SELECTIONS',
                    //     payload: {itemID: 0, prop: 'materials', value: newUserMaterials}
                    // });
                }
            } else {
                // THERE ARE SOME PREVIOUS SELECTIONS
                let itemSelectionsByKind = itemSelections.filter(option => option.kind === kind);
                let kindIndex = itemSelections.indexOf(itemSelectionsByKind[0]);

                if (selections.length === 0) {
                    // AND USER HAS DESELECTED OPTIONS FOR THE KIND
                    // console.log('2. USER HAVE DESELECTED OPTS IN', kind)
                    if (itemSelectionsByKind.length > 0) {
                        //THERE ARE PRIOR SELECTIONS FOR THIS EXACT KIND THAT MUST BE ELIMINATED
                        newUserArticles[index].options.splice(kindIndex, 1);

                        //========== TEMPORARY SOLUTION X CONSEGNA 03/08/22 TO REMOVE CUSHIONS ON DESELECTION. =============
                        let cushions = newUserArticles[index].options.filter(opt => opt.kind.toLowerCase() ===  'cushions');
                        let cushionsInd = newUserArticles[index].options.indexOf(cushions[0]);
                        if (cushions.length > 0){
                            newUserArticles[index].options.splice(cushionsInd, 1)
                        }
                        //==================================================================================================

                        // itemSelections.splice(kindIndex, 1);
                        // getNewMaterials(newUserArticles);
                        // if all kinds have been removed so that options length is 0 then options are set to undefined
                        if (itemSelections.length === 0) {
                            newUserArticles[index].options = undefined;
                            // getNewMaterials(newUserArticles);
                        } 
                    }  
                    
                } else {
                    // USER HAS SELECTED OPTIONS
                    // console.log('2. USER ADDED NEW OPTS IN', kind)
                    if (itemSelectionsByKind.length > 0) {
                        //THERE ARE PRIOR SELECTIONS FOR THIS EXACT KIND THAT MUST BE REPLACED
                        newUserArticles[index].options[kindIndex].articles = selections;
                        // itemSelectionsByKind[0].articles = selections
                    } else {
                        newUserArticles[index].options.push({
                            kind: kind,
                            articles: selections
                        })
                    };
                }
            };
        } else if (ids.length < articles.length) {
            articles.forEach(article => {
                if (!ids.includes(article.id)) {
                    let newItem = {...template};
                    Object.keys(newItem).forEach(key => {
                        newItem[key] = article[key];
                    });
                    newItem.options = undefined;
                    newItem.fabrics = undefined;
                    newItem.materials = undefined;
                    newUserArticles.push(newItem); 
                } 
            });
            console.log('ADDED ITEMS', newUserArticles)
        } else {
            ids.forEach( (id, _i) => {
                if (!articles.includes(id)) {
                    newUserArticles.splice(_i, 1)
                }
            });
        }
        // console.log('updated composition', newUserArticles)
        setUserArticles(newUserArticles);
        dispatch({
            type:  'SET_ARTICLES',
            payload: newUserArticles
        });
        getUserArticlesData(newUserArticles);
    };

    const updateFinishes = (kind, itemID, selections) => {
        console.log('UPDATING FINISHES', kind, itemID, selections);
        // dispatch({
        //     type: 'SET_MATERIALS',
        //     payload: {"materials": [         {           "kind": "Dew",           "colors": [1]         }       ] }
        // });
        let finishObj = {
            kind: kind,
            colors: selections
        };
        
        if (itemID === 'materials') {
            let currentMaterials = userMaterials.slice();
            let some = currentMaterials.filter(material => material.kind === kind);
            if (some.length > 0) {
                currentMaterials.splice(currentMaterials.indexOf(some[0]), 1, finishObj)
            } else {
                currentMaterials.push(finishObj)
            }
            setUserMaterials(currentMaterials);
            dispatch({
                type: 'SET_MATERIALS',
                payload: currentMaterials
            });
        };
        
        if (itemID === 'fabrics') {
            let currentFabrics = userFabrics.slice();
            currentFabrics.splice(0, 1, finishObj);
            setUserFabrics(currentFabrics);
            dispatch({
                type: 'SET_FABRICS',
                payload: currentFabrics
            });
        };
    }

    const updateComposition = (tab, kind, itemID, selections) => {
        switch (tab) {
            case 'modify'   : updateOptions(kind, itemID, selections);  break;
            case 'finishes' : updateFinishes(kind, itemID, selections); break;
            default         : console.error('no matching case for', tab);
        };
    };

    const deleteItem = (id) => {
        let articlesTemp = itemsList.slice();
        let ids = [];
        articlesTemp.forEach(article => {
            ids.push(article.id)
        });
        articlesTemp.splice(ids.indexOf(id), 1);
        dispatchCompositionArticles(dispatch, articlesTemp);
    };

    useEffect(() => {
        setActiveTab(tab);
    }, [tab]);

    useEffect(() => {
        setItemsList(articles);
        
        // getUserArticlesData(userArticles);
    }, [articles]);

   

    // useEffect(() => {
    //     if (materials && fabrics && articlesSelections !== undefined) {
    //         getUserArticlesData(articlesSelections);
    //     }
    // }, [materials, fabrics, articlesSelections])

    useEffect(() => {
        let isMounted = true;
        const getFabrics = async (itemFabrics) => {
            // let isMounted = true;
            await fetch (`${proxy}https://rodabackend.com/api/v1/fabric_families/`)
            .then(res => res.json())
            .then(async fabricFamilies => {
                if (isMounted) {
                    if (fabricFamilies) {
                        //api below disabled x consegna 03/08/22
                        // const data = await fetch (`${proxy}https://rodabackend.com/api/v1/fabric_colors/`);
                        const data = await fetch (`${proxy}https://rodabackend.com/mocked_api/v1/fabrics/`);
                        const fabricColors = await data.json();
                        if (fabricColors) {
                            // console.log('families', fabricFamilies)
                            // console.log('colors', fabricColors)
                            fabricFamilies.forEach(family => {
                                let colors = fabricColors.filter(color => color.family === family.id);
                                
                                colors.sort(function(a, b) {
                                    return a.id - b.id
                                })
                                family.kind = family.name;
                                family.colors = colors;
                            });
                            fabricFamilies.sort(function(a, b) {
                                return a.id - b.id
                            })
                            setFabrics(fabricFamilies);
                            // console.log('fabrics', fabricFamilies)
                        } else {
                            console.error('smth went wrong')
                        }
                    };
                };
            })
            .catch(error => {
                console.log(error)
            });

            
        };

        const getMaterials = async (itemMaterials) => {
            await fetch (`${proxy}https://rodabackend.com/mocked_api/v1/materials/`)
            .then(res => res.json())
            .then(data => {
                if (isMounted) {
                    if (data) {
                        //Data array contains image urls and color names
                        dispatch({
                            type: 'SET_RODA_MATERIALS',
                            payload: data
                        });
                        setRodaMaterials(data);
                        let materials = itemMaterials.slice();
                        materials.forEach((material, _i) => {
                            material.colors.forEach(color => {
                                let newData = data.filter(i => i.id === color)[0];
                                materials[_i].colors.splice(materials[_i].colors.indexOf(color), 1, newData)
                            })
                        });
                        setDefaultMaterials(materials);
                        // console.log('materials', materials)
                        setMaterials(materials);
                    };
                };
            })
            .catch(error => {
                console.log(error)
            });
            
        };

        if (userMaterials || userFabrics === undefined) {
            if (itemsList !== undefined) {
                let firsItemMet = itemsList[0];
                let keys = Object.keys(firsItemMet);

                let hasFabrics = keys.includes('fabrics'); setHasFabrics(hasFabrics);
                let hasMaterials = keys.includes('materials'); setHasMaterials(hasMaterials);
                
                //setting up default user material
                if (hasFabrics) {
                    let itemFabrics = JSON.parse(JSON.stringify(firsItemMet.fabrics));
                    if (userFabrics === undefined) {
                        // console.log('itemFabrics', itemFabrics)
                        let userSelections = [];
                        let kind = 'Dew';
                        let colors = [5];
                        userSelections.push({kind, colors});
                        setUserFabrics(userSelections);
                        dispatch({
                            type:  'SET_USER_SELECTIONS',
                            payload: {itemID: 0, prop: 'fabrics', value: userSelections}
                        });
                    };
                    getFabrics(itemFabrics);
                };

                if (hasMaterials) {
                    let itemMaterials = JSON.parse(JSON.stringify(firsItemMet.materials));
                    if (userMaterials === undefined) {
                        let userSelections = [];
                        itemMaterials.forEach(material => {
                            let kind = JSON.parse(JSON.stringify(material.kind));
                            let colors = JSON.parse(JSON.stringify(material.colors));
                            let color = []; //it's an array but must contain just one color to be used as user selection
                            color.push(colors[0]);
                            userSelections.push({kind, colors: color});
                        })
                        
                        setUserMaterials(userSelections);
                        dispatch({
                            type: 'SET_MATERIALS',
                            payload: userSelections
                        });
                        // dispatch({
                        //     type:  'SET_USER_SELECTIONS',
                        //     payload: {itemID: 0, prop: 'materials', value: userSelections}
                        // });
                    } ;
                    // if (!isShared) {
                    //     console.log('am i doing some shit 2')
                    //     getMaterials(itemMaterials);
                    // }
                    
                };

                let updatedSpecs = [];
                if (itemsList.length > 0) {
                    let dataObj = {
                        id: itemsList[0].id, 
                        full_name: itemsList[0].full_name, 
                        image: itemsList[0].image, 
                        measurements: itemsList[0].measurements
                    };
                    updatedSpecs.push(dataObj);
                };
                setSpecs(updatedSpecs);
            };
            if (articlesSelections !== undefined && articlesSelections.length > 0 && articles !== undefined) {
                setUserArticles(articlesSelections);
                getUserArticlesData(articlesSelections);
            }
            setFirstLoad(false);
        };
        
        return () => {
            isMounted = false;
        };
    }, [firstLoad, itemsList, proxy, dispatch, userFabrics, userMaterials, isShared, articlesSelections, articles]);

    // useEffect(() => {
    //     if (articlesSelections !== undefined && articlesSelections.length > 0 && articles !== undefined) {
    //         setUserArticles(articlesSelections);
    //         getUserArticlesData(articlesSelections);
    //     }
        
    // }, [articlesSelections, articles])

    // useEffect(() => {
    //     console.log('user selection', appState.selections)
    // }, [appState.selections])


    return (
        <div className={isSideMenuOpen ? 'sidemenu' : 'sidemenu collapsed'}>
            <Navbar 
                type={isSummaryOpen ? 'summary' : ''}
                buttons={isSummaryOpen ? SUMMARY_BUTTONS : TABS }
            />
            <div className='sidemenu-list'>
                {   
                    isSummaryOpen  ? <Summary/> : <> {
                        activeTab === 'modify' && itemsList && itemsList.map((article) => {
                            return  (
                                <ListItem
                                    key={article.item_id}
                                    tab={activeTab}
                                    itemID={article.item_id}
                                    name={article.full_name}
                                    activeItems={activeItems}
                                    updateActiveItems={updateActiveItems}
                                    itemOptions={article.options}
                                    userSelections={userArticles}
                                    updateComposition={updateComposition}
                                    deleteItem={deleteItem}
                                />
                            )
                        })
                    }
                    {
                        activeTab === 'finishes' && hasMaterials ? console.log('USER MATERIALS!!!',  userMaterials) : null
                    }
                    {
                        activeTab === 'finishes' && hasMaterials && <ListItem
                            key={'finishes_materials'}
                            tab={activeTab}
                            itemID={'materials'}
                            name={'materials'}
                            activeItems={activeItems}
                            updateActiveItems={updateActiveItems}
                            itemOptions={materials}
                            userSelections={userMaterials}
                            updateComposition={updateComposition}
                        />
                    }
                    {
                        activeTab === 'finishes' && hasFabrics && <ListItem
                            key={'finishes_fabrics'}
                            tab={activeTab}
                            itemID={'fabrics'}
                            name={'fabrics'}
                            activeItems={activeItems}
                            updateActiveItems={updateActiveItems}
                            itemOptions={fabrics}
                            userSelections={userFabrics}
                            updateComposition={updateComposition}
                        />
                    }
                </>
                }
            </div>
        </div>
    )
};

export default SideMenu;